let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("86UZc")).then(() => parcelRequire('ixBjC'));